import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {groupsTabStateSelector} from './groups-tab-state.slice';

import type {GroupSortField, GroupsTabFilters} from '../typedef';
import type {CachedTableCacheSelector, CachedTableDataSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountGroupShortInfo} from 'src/openapi/admin/models/AccountGroupShortInfo';


export const groupsTabSlice = getCachedTableDataSlice<
    AccountGroupShortInfo[],
    undefined,
    GroupSortField,
    GroupsTabFilters
>('groupsTab');

export const groupsTabActions = groupsTabSlice.actions;
export const groupsTabCacheSelector: CachedTableCacheSelector<AccountGroupShortInfo[]> =
    state => state.accountPage.tabs.usersAndGroups.accountGroups.result.cache;
export const groupsTabDataSelector: CachedTableDataSelector<AccountGroupShortInfo[]> =
    state => state.accountPage.tabs.usersAndGroups.accountGroups.result;

export const groupsTabResultSelector = getCachedTableResultSelector(
    groupsTabCacheSelector,
    groupsTabStateSelector,
);
